
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M8.57546 11.1509C9.30514 11.1509 9.91874 10.6534 10.1012 9.99005H16.8507V9.16086H10.1012C9.91874 8.49751 9.30514 8 8.57546 8C7.7131 8 7 8.7131 7 9.57546C7 10.4544 7.7131 11.1509 8.57546 11.1509Z",
        "fill": "#40454E"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M15.4247 13.771C14.695 13.771 14.0814 14.2685 13.8989 14.9319H7.09961V15.761H13.8989C14.0814 16.4244 14.695 16.9219 15.4247 16.9219C16.287 16.9219 17.0001 16.2088 17.0001 15.3465C17.0001 14.4841 16.287 13.771 15.4247 13.771Z",
        "fill": "#40454E"
      }
    }
  ]
})
    }
  